module.exports = __webpack_public_path__ + "img/Weapon_295.5a630185.png";